import {CreativeBean} from 'common/api/api.ts'

export const videoAspectRatioOptions: Record<CreativeBean.AspectRatioEnum, {width: number; height: number; label: string}> = {
    [CreativeBean.AspectRatioEnum.Ratio1x1]: {width: 1, height: 1, label: '1:1'},
    [CreativeBean.AspectRatioEnum.Ratio16x9]: {width: 16, height: 9, label: '16:9'},
    [CreativeBean.AspectRatioEnum.Ratio9x16]: {width: 9, height: 16, label: '9:16'},
    [CreativeBean.AspectRatioEnum.Ratio16x10]: {width: 16, height: 10, label: '16:10'},
    [CreativeBean.AspectRatioEnum.Ratio10x16]: {width: 10, height: 16, label: '10:16'},
    [CreativeBean.AspectRatioEnum.Ratio4x3]: {width: 4, height: 3, label: '4:3'},
    [CreativeBean.AspectRatioEnum.Ratio3x4]: {width: 3, height: 4, label: '3:4'},
    [CreativeBean.AspectRatioEnum.Ratio3x2]: {width: 3, height: 2, label: '3:2'},
    [CreativeBean.AspectRatioEnum.Ratio2x3]: {width: 2, height: 3, label: '2:3'},
}

export const videoAspectRatioEnumValues = Object.values(CreativeBean.AspectRatioEnum) as CreativeBean.AspectRatioEnum[]

export const getVideoAspectRatioLabel = (aspectRatio: CreativeBean.AspectRatioEnum) =>
    videoAspectRatioOptions[aspectRatio]?.label || aspectRatio

export const matchesVideoAspectRatio = (aspectRatio: CreativeBean.AspectRatioEnum | undefined, width: number, height: number) => {
    if (!aspectRatio || width <= 0 || height <= 0) return false
    const ratio = videoAspectRatioOptions[aspectRatio]
    if (!ratio) return false
    return width * ratio.height === height * ratio.width
}

const greatestCommonDivisor = (a: number, b: number): number => {
    let dividend = Math.abs(a)
    let divisor = Math.abs(b)

    while (divisor !== 0) {
        const remainder = dividend % divisor
        dividend = divisor
        divisor = remainder
    }

    return dividend || 1
}

export const getAspectRatioLabelForSize = (width: number, height: number) => {
    const matched = videoAspectRatioEnumValues.find((ratio) => matchesVideoAspectRatio(ratio, width, height))
    if (matched) {
        return getVideoAspectRatioLabel(matched)
    }
    const divisor = greatestCommonDivisor(width, height)
    return `${width / divisor}:${height / divisor}`
}
